


export class LogProcessamentoSistema {
  "Mensagem";
  "Rotina";
  "TipoLog";
  "DataLog";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LogProcessamentoSistema`.
   */
  static getModelName() {
    return "LogProcessamentoSistema";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LogProcessamentoSistema for dynamic purposes.
  **/
  static factory(data) {
    return new LogProcessamentoSistema(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'LogProcessamentoSistema',
      plural: 'LogProcessamentoSistemas',
      path: 'LogProcessamentoSistemas',
      properties: {
        "Mensagem": {
          name: 'Mensagem',
          type: 'string'
        },
        "Rotina": {
          name: 'Rotina',
          type: 'string'
        },
        "TipoLog": {
          name: 'TipoLog',
          type: 'string'
        },
        "DataLog": {
          name: 'DataLog',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/LogProcessamentoSistema.js